import { UserAuthClient } from './httpClient';

export const getUserAcceptedTermsHasAccepted = async (email) => {
  const acceptedTerms = sessionStorage.getItem('tcAcceptCache') === 'true';
  if (acceptedTerms) return true;

  const response = await UserAuthClient.get(
    `users/termsAndConditions?email=${email}`
  );
  return response.data;
};

export const setUserAcceptedTermsHasAccepted = async (email) => {
  sessionStorage.setItem('tcAcceptCache', 'true');

  const response = await UserAuthClient.post(
    `users/termsAndConditions?email=${email}`
  );
  return response.data;
};
